import { Link } from "@tanstack/react-router";
import * as m from "~/paraglide/messages.js";

/** Who is behind the system, before the page asks for a conversation. */
export function StudioNote() {
  return (
    <section className="studio-note wrap" id="company">
      <div>
        <p className="studio-label">{m.home_studio_label()}</p>
        <h2>
          {m.home_studio_title_1()} <br />
          {m.home_studio_title_2()}
        </h2>
      </div>

      <div>
        <p>{m.home_studio_lede()}</p>
        <Link className="quiet-link" to="/about">
          {m.home_studio_cta()} <span aria-hidden="true">↗</span>
        </Link>
        <span className="studio-location">{m.home_studio_location()}</span>
      </div>
    </section>
  );
}
